import { Component, Mixins } from "vue-property-decorator";
import MarketSegmentsMixin from "@/mixins/http/SpecialInitiatives/MarketSegmentsMixin";
import store from "@/store";

@Component
class SpecialInitiativesMarketSegmentsService extends Mixins(
  MarketSegmentsMixin
) {
  created() {
    this.$store = store;
  }

  getMarketSegments() {
    return this.index();
  }
}

export default new SpecialInitiativesMarketSegmentsService();
